import ErrorState from "@/components/common/ErrorState";

export default function RouteErrorPage() {
  return <ErrorState title="Route error" />;
}
